/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateDiscreteNumericListDto } from './CreateDiscreteNumericListDto';
import {
    instanceOfCreateDiscreteNumericListDto,
    CreateDiscreteNumericListDtoFromJSON,
    CreateDiscreteNumericListDtoFromJSONTyped,
    CreateDiscreteNumericListDtoToJSON,
} from './CreateDiscreteNumericListDto';
import type { CreateDiscreteNumericValueDto } from './CreateDiscreteNumericValueDto';
import {
    instanceOfCreateDiscreteNumericValueDto,
    CreateDiscreteNumericValueDtoFromJSON,
    CreateDiscreteNumericValueDtoFromJSONTyped,
    CreateDiscreteNumericValueDtoToJSON,
} from './CreateDiscreteNumericValueDto';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    instanceOfCreateEnumerationValueDto,
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateEnumerationValueListDto } from './CreateEnumerationValueListDto';
import {
    instanceOfCreateEnumerationValueListDto,
    CreateEnumerationValueListDtoFromJSON,
    CreateEnumerationValueListDtoFromJSONTyped,
    CreateEnumerationValueListDtoToJSON,
} from './CreateEnumerationValueListDto';
import type { CreateNumericListDto } from './CreateNumericListDto';
import {
    instanceOfCreateNumericListDto,
    CreateNumericListDtoFromJSON,
    CreateNumericListDtoFromJSONTyped,
    CreateNumericListDtoToJSON,
} from './CreateNumericListDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    instanceOfCreateNumericValueDto,
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';
import type { CreateTextValueDto } from './CreateTextValueDto';
import {
    instanceOfCreateTextValueDto,
    CreateTextValueDtoFromJSON,
    CreateTextValueDtoFromJSONTyped,
    CreateTextValueDtoToJSON,
} from './CreateTextValueDto';

/**
 * @type ICreateSingleSystemSetupParameter
 * 
 * @export
 */
export type ICreateSingleSystemSetupParameter = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateEnumerationValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateEnumerationValueListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateDiscreteNumericListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateDiscreteNumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateNumericListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateNumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateTextValueDto;


export function ICreateSingleSystemSetupParameterFromJSON(json: any): ICreateSingleSystemSetupParameter {
    return ICreateSingleSystemSetupParameterFromJSONTyped(json, false);
}

export function ICreateSingleSystemSetupParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateSingleSystemSetupParameter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateEnumerationValueDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateEnumerationValueListDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateDiscreteNumericListDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateDiscreteNumericValueDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateNumericListDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericListDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateNumericValueDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateTextValueDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of ICreateSingleSystemSetupParameter exists with '$type=${json['$type']}'`);
    }
}

export function ICreateSingleSystemSetupParameterToJSON(value?: ICreateSingleSystemSetupParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateEnumerationValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateEnumerationValueListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateDiscreteNumericListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateDiscreteNumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateNumericListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateNumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateTextValueDtoToJSON(value);
        default:
            throw new Error(`No variant of ICreateSingleSystemSetupParameter exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ICreateSingleSystemSetupParameter interface.
 */
export function instanceOfICreateSingleSystemSetupParameter(value: any): value is ICreateSingleSystemSetupParameter {
    if (instanceOfCreateEnumerationValueDto(value)) return true;
    if (instanceOfCreateEnumerationValueListDto(value)) return true;
    if (instanceOfCreateDiscreteNumericListDto(value)) return true;
    if (instanceOfCreateDiscreteNumericValueDto(value)) return true;
    if (instanceOfCreateNumericListDto(value)) return true;
    if (instanceOfCreateNumericValueDto(value)) return true;
    if (instanceOfCreateTextValueDto(value)) return true;
    return false;
}

